import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Bain & Company section on Partners page
 */
const BainSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="bain-section-component">
      <AccordionV2
        testId="bain"
        className="border-x py-4"
        headerChildren={<EventsAwardsAccordionHeader title="Bain & Company" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>About Bain & Company</p>

          <p>
            Bain & Company is a global consultancy that helps the world&apos;s
            most ambitious change makers define the future.
          </p>

          <p>
            Across 65 cities in 40 countries, we work alongside our clients as
            one team with a shared ambition to achieve extraordinary results,
            outperform the competition, and redefine industries. We complement
            our tailored, integrated expertise with a vibrant ecosystem of
            digital innovators to deliver better, faster, and more enduring
            outcomes. Our 10-year commitment to invest more than $1 billion in
            pro bono services brings our talent, expertise, and insight to
            organizations tackling today&apos;s urgent challenges in education,
            racial equity, social justice, economic development, and the
            environment. We earned a platinum rating from EcoVadis, the leading
            platform for environmental, social, and ethical performance ratings
            for global supply chains, putting us in the top 1% of all companies.
            Since our founding in 1973, we have measured our success by the
            success of our clients, and we proudly maintain the highest level of
            client advocacy in the industry.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default BainSection;
